import { createFileRoute } from "@tanstack/react-router";

import { ClientApprovalsPage } from "@/components/marketing/client-approvals-page";
import { clientApprovalsHead } from "@/lib/seo";

export const Route = createFileRoute("/(public)/client-approvals")({
  /*
   * The FAQs come from the loader, not a module-scope import, so they stay out
   * of the entry chunk (see `help.$slug`). On the server it also loads the plan
   * catalog, for the same reason as /pricing: the page quotes the price of the
   * plan that includes approvals, and crawlers that do not run JavaScript
   * should read it in the prerendered HTML. The browser refetches it.
   */
  loader: async ({ context }) => {
    const { APPROVAL_FAQS } = await import(
      "@/components/marketing/client-approvals-data"
    );

    if (typeof window === "undefined") {
      try {
        await context.queryClient.ensureQueryData(
          context.trpc.billing.listPlans.queryOptions(),
        );
      } catch (cause) {
        console.warn(
          "[client-approvals] billing.listPlans failed while rendering",
          cause,
        );
      }
    }

    return { faqs: APPROVAL_FAQS };
  },
  head: ({ loaderData }) =>
    loaderData ? clientApprovalsHead(loaderData.faqs) : {},
  component: ClientApprovalsPage,
});
